"use client";
import { cva as e } from "class-variance-authority";
const t = e("tracking-tight font-semibold", {
  variants: {
    size: {
      lg: "text-xl",
      md: "text-md"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), a = e("text-2sm ms-[1em] break-words pb-3 pl-7 relative [&_li]:mb-1", {
  variants: {
    style: {
      ordered: "list-decimal [counter-increment:item]",
      unordered: "list-[initial]"
    }
  }
}), o = e("", {
  variants: {
    slot: {
      root: "w-full border-collapse [font-variant-numeric:lining-nums_tabular-nums]",
      th: [
        "font-heading font-bold uppercase tracking-wider text-start",
        "data-[is-numeric=true]:text-end",
        "border-b border-gray-100 dark:border-gray-700",
        "text-gray-600 dark:text-gray-400",
        // Sizing
        "px-6 py-3 leading-4 text-xs"
      ],
      td: [
        "text-start data-[is-numeric=true]:text-end",
        "border-b border-gray-100 dark:border-gray-700",
        // Sizing
        "px-6 py-4 leading-5"
      ]
    },
    size: {
      md: ""
    }
  }
}), i = e([
  "ml-[3px] cursor-pointer",
  "[&_a]:bg-inkeep-primary-light",
  "[&_a]:px-1",
  "[&_a]:py-[1px]",
  "[&_a]:rounded-sm",
  "[&_a]:no-underline",
  "[&_a]:text-inkeep-primary-text-subtle",
  "[&_a]:hover:text-inkeep-primary-text-bold",
  "[&_a]:font-semibold",
  "[&_a]:dark:bg-inkeep-primary-text-subtle",
  "[&_a]:dark:hover:text-inkeep-expanded-primary-200",
  "[&_a]:hover:no-underline"
]), n = e([
  "bg-inkeep-primary-medium text-inkeep-primary-text-color-on-primary",
  "[overflow-wrap:anywhere] min-w-0 py-[.2rem] my-[.1rem]",
  "px-[.4rem] rounded-[6px] [font-size:85%!important]",
  "font-semibold inline-block",
  "font-mono "
]), d = e("", {
  variants: {
    slot: {
      container: "overflow-y-auto mb-3",
      header: [
        "flex items-center justify-between",
        "bg-gray-50 dark:bg-gray-dark-800",
        "text-gray-600 dark:text-gray-400",
        "mb-0 leading-[1.25] px-2 text-xs",
        "transition-all duration-200 ease-in-out",
        "rounded-[6px_6px_0_0]"
      ],
      copyButton: [
        "px-0 bg-inherit text-inherit",
        "hover:text-gray-800 dark:text-white-alpha-700 dark:hover:text-white-alpha-950",
        "dark:hover:bg-transparent h-8 w-8 min-h-8 min-w-8 text-sm",
        "data-[copied]:text-inkeep-primary-medium"
      ],
      highlighter: [
        "text-1sm overflow-x-auto",
        "rounded-[0_0_6px_6px]",
        "p-[1em] whitespace-pre",
        "m-[0px_0px_0.5em]",
        "bg-gray-50 dark:bg-gray-dark-900",
        "[scrollbar-width:thin]",
        "[--scrollbar-color:var(--color-gray-300)]",
        "dark:[--scrollbar-color:var(--color-gray-dark-600)]",
        "[scrollbar-color:var(--scrollbar-color)_transparent]"
      ]
    }
  }
});
export {
  n as code,
  d as codeblock,
  t as heading,
  a as list,
  i as sup,
  o as table
};
